// extracted by mini-css-extract-plugin
export default {"modal":"WrongRoleModal_modal__W9HW4","modal_close_button":"WrongRoleModal_modal_close_button__JDdlf"};